// extracted by mini-css-extract-plugin
export var chatHtmlText = "_tj-2";
export var chatLink = "_tj-0";
export var chatText = "_tj-1";